var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon-travel_flexibly_svg__filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    strokeWidth: 0,
    fill: "currentColor",
    className: "RoomPanelMealPlanOptions__StyledIconShield-sc-7dp7iy-26 jQvrxa",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.46,18.22,24.12,27l-3.71-3.7a2,2,0,0,0-2.82,2.82l5.25,5.25a2,2,0,0,0,1.41.59h.09a2,2,0,0,0,1.45-.72l8.75-10.5a2,2,0,0,0-3.08-2.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47,11.55a1,1,0,0,0-.58-.87C45.9,10.45,33.91,5,26,5,17.32,5,6.05,10.46,5.57,10.69a1,1,0,0,0-.56.86c0,.51-.36,12.62,4.53,21.6S25.16,46.73,25.61,46.92a1,1,0,0,0,.78,0c.45-.19,11.15-4.74,16.07-13.77S47,12.06,47,11.55ZM37.94,30.37c-3.46,6.47-11.23,9.75-11.56,9.89a1.07,1.07,0,0,1-.76,0c-.33-.14-8.1-3.42-11.57-9.89s-3.52-14-3.52-14.36a1,1,0,0,1,.52-.89c.35-.19,8.52-4.56,15-4.56s14.59,4.37,14.94,4.56a1,1,0,0,1,.53.89C41.47,16.33,41.36,24,37.94,30.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeCancellation);
export default __webpack_public_path__ + "static/media/freeCancellation.0e68b2e454c0928ca2472829af7005b6.svg";
export { ForwardRef as ReactComponent };